module.exports = __webpack_public_path__ + "b1b03f76273177176434141d199180c5.svg";